"use strict";

import "./Table.css";
import React from "react";
import classnames from "classnames";
import {getScalarVehicleStatesWithResolvedUnits} from "./../../../../utils/vehicle";
import lang from "vwa/lang";
import round from "vwa/utils/round";

export default class Table extends React.Component {
		
	getRowDataFromVehicleState() {
		
		if (!this.props.vehicleState || Object.keys(this.props.vehicleState).length == 0)
			return [];
		
		const ignoredNames = ["Position", "Ignition", "InputVector", "OutputVector"];
		
		const rows = [];
		
		for (let dataTypeName in this.props.vehicleState) {
			if (ignoredNames.indexOf(dataTypeName) > -1) continue;
			const data = this.props.vehicleState[dataTypeName];
			rows.push({
				dataTypeName:	dataTypeName,
				name:			data.name,
				value:			data.value + " " + data.unit
			});
		}
		
		return rows;
	}
	
	renderRow(rowData) {
		if( rowData.dataTypeName == lang["DATA_TYPE_54ac0f62f556ea16b4a31fd4"]) //"Position"
			{				
				return (
					<tr key={rowData.dataTypeName}>
						<td>{rowData.name}</td>
						<td>{"Lat:"+round(rowData.lat,4)}</td>
						<td>{"Lng:"+round(rowData.lng,4)}</td>
					</tr>
				);
			};
		return (
			<tr key={rowData.dataTypeName}>
				<td>{rowData.name}</td>
				<td>{`${rowData.value} ${rowData.unit}`}</td>
			</tr>
		);
	}
	
	render() {
		const className = classnames("Table", {"Hidden": !this.props.shown});
		const rowData = getScalarVehicleStatesWithResolvedUnits(this.props.vehicle._id);
		return (
			<table className={className}>
				<tbody>
					{rowData.map(rd => this.renderRow(rd))}
				</tbody>
			</table>
		);
	}
	
}

Table.propTypes = {
	shown:			React.PropTypes.bool,
	vehicle:		React.PropTypes.object.isRequired
};

Table.defaultProps = {
	shown: true
};


// WEBPACK FOOTER //
// ./src/view/VehicleList/Summary/Table/Table.jsx